﻿(function () {
	'use strict';

	angular.module('nha.portal').service('config-frontend-web-source.repository', configFrontEndWebSourceRepo);

	configFrontEndWebSourceRepo.$inject = ['PortalRestangular', 'baseService'];

	function configFrontEndWebSourceRepo(portalRestangular, baseService) {
		/** create the repo */
		var repo = {
			endpoint: 'ConfigFrontEndWebSource',
			getKeys: getKeys,
			getEnvironments: getEnvironments
		};

		/** public methods */

		function getKeys() {
			return baseService.getList(repo.endpoint.concat('/keys/'), null, false, false, portalRestangular);
		}

		function getEnvironments() {
			return baseService.getList(repo.endpoint.concat('/environments/'), null, false, false, portalRestangular);
		}

		/** return the repo */
		return repo;
	}
}());